import { render, staticRenderFns } from "./CloudForum.vue?vue&type=template&id=be0cca68&scoped=true"
import script from "./CloudForum.vue?vue&type=script&lang=js"
export * from "./CloudForum.vue?vue&type=script&lang=js"
import style0 from "./CloudForum.vue?vue&type=style&index=0&id=be0cca68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be0cca68",
  null
  
)

export default component.exports